import { AxiosError } from 'axios';

export interface StockError {
  type: 'disabled' | 'insufficient_stock';
  message: string;
  availableStock?: number;
  requestedQuantity?: number;
}

export const handleStockError = (error: any): StockError | null => {
  if (error instanceof AxiosError && error.response?.data?.detail) {
    const detail = error.response.data.detail as string;
    
    // Check for disabled item error
    if (detail === 'Item is not available for purchase') {
      return {
        type: 'disabled',
        message: 'Item is not available for purchase'
      };
    }
    
    // Check for insufficient stock error
    if (detail.startsWith('Insufficient stock')) {
      const match = detail.match(/Available: (\d+), Requested: (\d+)/);
      if (match) {
        const availableStock = parseInt(match[1]);
        const requestedQuantity = parseInt(match[2]);
        return {
          type: 'insufficient_stock',
          message: `Insufficient stock. Available: ${availableStock}, Requested: ${requestedQuantity}`,
          availableStock,
          requestedQuantity
        };
      }
    }
  }
  
  return null;
};

export const getStockErrorMessage = (stockError: StockError, t: (key: string, options?: any) => string): string => {
  switch (stockError.type) {
    case 'disabled':
      return t('stock.itemNotAvailable');
    case 'insufficient_stock':
      return t('stock.insufficientStock', { 
        available: stockError.availableStock, 
        requested: stockError.requestedQuantity 
      });
    default:
      return stockError.message;
  }
}; 